import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TimedDifficultySelectionScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Expect username and variant from previous screen.
  const { username, variant } = location.state || {};
  if (!username || !variant) {
    navigate("/");
    return null;
  }

    // eslint-disable-next-line react-hooks/rules-of-hooks
  const [difficulty, setDifficulty] = useState("");

  const handleContinue = () => {
    if (!difficulty) {
      alert("Please select a difficulty.");
      return;
    }
    // Navigate to the appropriate timed quiz screen with the chosen difficulty.
    if (variant === "personalized") {
      navigate("/timed-personalized", { state: { username, difficulty } });
    } else {
      navigate("/timed-random", { state: { username, difficulty } });
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Select Difficulty</h2>
      <p style={styles.subtitle}>Choose a difficulty level for your timed quiz.</p>
      <button
        style={{
          ...styles.button,
          backgroundColor: difficulty === "Easy" ? "#87ceeb" : "#4682b4",
        }}
        onClick={() => setDifficulty("Easy")}
      >
        Easy
      </button>
      <button
        style={{
          ...styles.button,
          backgroundColor: difficulty === "Medium" ? "#87ceeb" : "#4682b4",
        }}
        onClick={() => setDifficulty("Medium")}
      >
        Medium
      </button>
      <button
        style={{
          ...styles.button,
          backgroundColor: difficulty === "Hard" ? "#87ceeb" : "#4682b4",
        }}
        onClick={() => setDifficulty("Hard")}
      >
        Hard
      </button>
      <button style={{ ...styles.button, marginTop: '20px' }} onClick={handleContinue}>
        Continue
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e6f0fa',
    padding: '20px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#4682b4',
    marginBottom: '1rem'
  },
  subtitle: {
    fontSize: '1.5rem',
    color: '#4682b4',
    marginBottom: '1.5rem'
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    margin: '0.5rem',
    borderRadius: '8px',
    backgroundColor: '#4682b4',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    width: '80%',
    maxWidth: '300px'
  }
};

export default TimedDifficultySelectionScreen;
